<template lang="pug">
el-dialog(
  :title="title",
  width="95%",
  :visible.sync="visible",
  :modal-append-to-body="false",
  :append-to-body="true"
)
  el-form(
    :model="ruleForm",
    :inline="false",
    :rules="rules",
    ref="ruleForm",
    label-width="120px"
  )
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 比赛设置
      .labelStyle
        el-form-item(label="比赛ID:", prop="matchId")
          font {{ ruleForm.matchId }}
        el-form-item(label="比赛名称:", prop="matchName")
          font {{ ruleForm.matchName }}
        el-form-item(label="主办方:", prop="orgName")
          font {{ ruleForm.orgName }}
        el-form-item(label="主办城市:", prop="cityName")
          font {{ ruleForm.provinceName }}&nbsp;{{ ruleForm.cityName }}
        el-form-item(label="比赛场地:", prop="placeName")
          font {{ ruleForm.placeName }} &nbsp;&nbsp;&nbsp;地址: {{ ruleForm.venueAddress }}
        el-form-item(label="比赛类型:", prop="ctType")
          font(v-if="ruleForm.ctType === 1") 常规赛
          font(v-if="ruleForm.ctType === 2") 月度赛
          font(v-if="ruleForm.ctType === 3") 季度赛
          font(v-if="ruleForm.ctType === 4") 年度总决赛
        el-form-item(label="签位:", prop="applySize")
          font {{ ruleForm.applySize }}
        el-form-item(label="比赛项目:", prop="projectType")
          font(v-if="ruleForm.projectType === 1") 单打
          font(v-if="ruleForm.projectType === 2") 双打
          font(v-if="ruleForm.projectType === 3") 双打配对赛
        el-form-item(
          label="双打级别差:",
          prop="doubleLevelGap",
          v-if="ruleForm.projectType == 2"
        )
          font {{ ruleForm.doubleLevelGap }}
        el-form-item(label="级别:", prop="level")
          font {{ ruleForm.level }}
          //- 添加无赛中模式
        el-form-item(label="赛中管理模式:", prop="inGameManagementMode")
          font(v-if="ruleForm.inGameManagementMode == 1") 赛中管理
          font(v-if="ruleForm.inGameManagementMode == 0") 无赛中管理
        el-form-item(
          label="第一阶段赛制:",
          v-if="ruleForm.inGameManagementMode == 1"
        )
          font {{ CompetitionSelection(ruleForm.competitionMatchFormatList, 1) }}&nbsp;&nbsp;&nbsp; 组数：{{ CompetitionSelection(ruleForm.competitionMatchFormatList, 11) }}&nbsp;&nbsp;&nbsp; 设置附加规则：{{ ruleForm.competitionMatchFormatList[0].allowPlayOff | dealAllowPlayOff }}&nbsp;&nbsp;&nbsp; 小组晋级人数：{{ ruleForm.competitionMatchFormatList[0].groupRiseNum }}
        el-form-item(
          label="第二阶段赛制:",
          v-if="ruleForm.inGameManagementMode == 1"
        )
          font {{ CompetitionSelection(ruleForm.competitionMatchFormatList, 2) }}&nbsp;&nbsp;&nbsp; 交叉数：{{ CompetitionSelection(ruleForm.competitionMatchFormatList, 22) }}&nbsp;&nbsp;&nbsp; 设置附加规则：{{ CompetitionSelection1(ruleForm.competitionMatchFormatList, 2) }}
        el-form-item(label="是否替补:", prop="bench")
          font(v-if="ruleForm.bench == 1") 是
          font(v-if="ruleForm.bench == 0") 否
        el-form-item(label="联系电话:", prop="contactMobile")
          font {{ ruleForm.contactMobile || '--' }}
        //- el-form-item(label="是否首页推荐:")
        //-     font(v-if="ruleForm.recommend == 1") 是
        //-     font(v-if="ruleForm.recommend == 0") 否
        el-form-item(label="报名时间:", prop="applyDate")
          font {{ ruleForm.matchSignStartTime }}&nbsp;至&nbsp;{{ ruleForm.matchSignEndTime }}
        el-form-item(label="比赛时间:", prop="matchStartTime")
          font {{ ruleForm.matchStartTime }}
        el-form-item(label="列表页图:", prop="imgList")
          <img :src="listImageUrl" :onerror="defaultImg" style="width:256px;height:190px;"/>
        el-form-item(label="详情页图:", prop="imgDetailList")
          <img :src="detailImageUrl" :onerror="defaultImg" style="width:750px;height:310px;"/>
        el-form-item(label="比赛简介:", prop="matchDescription")
          <div v-html="ruleForm.matchDescription"></div>   
        el-form-item(label="报名须知:", prop="gameDescription")
          <div v-html="ruleForm.gameDescription"></div> 
        el-form-item(label="比赛规程:", prop="gameDescription")
          <div v-for="(item,index) in pdfs" style="display:flex">
            <div style="width:600px"> {{ item.fileName }}</div>
            <a :href="item.url" target="_blank" style="text-decoration: none"> 下载</a>
          </div>
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名限定
      .labelStyle
        el-form-item(label="重复报名:", prop="repeatSign")
          font(v-if="ruleForm.repeatSign === 1") 允许
          font(v-if="ruleForm.repeatSign === 0") 不允许
        el-form-item(label="性别限定:", prop="genderLimit")
          font(v-if="ruleForm.genderLimit === 2") 不限
          font(v-if="ruleForm.genderLimit === 0") 男
          font(v-if="ruleForm.genderLimit === 1") 女
        el-form-item(label="年龄限定:")
          div(v-if="ruleForm.genderLimit === 2")
            font(v-if="!ruleForm.ageMinMen && !ruleForm.ageMaxMen") 不限
            font(v-if="!(!ruleForm.ageMinMen && !ruleForm.ageMaxMen)") 男选手&nbsp;{{ ruleForm.ageMinMen }}-{{ ruleForm.ageMaxMen }}岁
            font(v-if="!(!ruleForm.ageMinWomen && !ruleForm.ageMaxWomen)") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;女选手&nbsp;{{ ruleForm.ageMinWomen }}-{{ ruleForm.ageMaxWomen }}岁
          div(v-if="ruleForm.genderLimit === 0")
            font 男选手&nbsp;{{ ruleForm.ageMinMen }}-{{ ruleForm.ageMaxMen }}岁
          div(v-if="ruleForm.genderLimit === 1")
            font 女选手&nbsp;{{ ruleForm.ageMinWomen }}-{{ ruleForm.ageMaxWomen }}岁
        el-form-item(label="级别限定:")
          font {{ ruleForm.minLevel }} - {{ ruleForm.maxLevel }}
        el-form-item(label="年度积分≥", prop="scoreMin")
          font {{ ruleForm.scoreMin || 0 }}
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名费用
      div
        el-table(:data="tableData", border)
          el-table-column(prop="dataName", label="角色", align="center")
          el-table-column(prop="type", label="报名费用", align="center")
            template(slot-scope="scope")
              font ￥&nbsp;{{ scope.row.price }}元
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 退款设置
      div
        el-table(:data="ruleForm.ctRefundList", border)
          el-table-column(
            prop="index",
            label="序号",
            align="center",
            width="100"
          )
          el-table-column(
            prop="minDuration",
            label="距比赛开始时间/小时（含）",
            align="center"
          )
          el-table-column(prop="refundScale", label="退款比例/%", align="center")
    br
    el-card(shadow="never")
      div(slot="header")
        el-form-item.comecs(label="电子证书图:", prop="imgList")
          .infocont(v-for="(item, index) in ruleForm.ecertList")
            <img  :src="item.imgUrl" :onerror="defaultImg" style="width:240px;height:174px"/>
            span {{ item.rewardLevel == 1 ? "一等奖" : item.rewardLevel == 2 ? "二等奖" : item.rewardLevel == 3 ? "三等奖" : item.rewardLevel == 4 ? "四等奖" : "" }}
    br
    el-card(shadow="never", v-if="type == 'release'")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 审核意见
      div
        el-form-item(prop="verifyReason", label="填写审核意见:")
          el-input(
            v-model="ruleForm.verifyReason",
            type="textarea",
            :rows=5,
            resize="none"
          )
  span.dialog-footer(slot="footer", v-if="!type")
    el-button(@click="visible = false") 返 回
  //- //审核发布
  span.dialog-footer(slot="footer", v-if="type == 'release'")
    el-button(@click="releaseSubmit(2)", type="primary" :disabled="btnLoading") 发 布
    el-button(@click="releaseSubmit(5)", type="danger" :disabled="btnLoading") 拒 绝
    el-button(@click="visible = false") 取 消
  //- //支付弹窗组件
  zfpage(
    :openfree="visibleFee",
    :record="record",
    v-if="visibleFee",
    @zfsuccess="zfsuccess"
  )
</template>
<script>
import zfpage from "../zfpage.vue";
export default {
  components: {
    zfpage,
  },
  data() {
    return {
      pdfs: [],
      visibleFee: false,
      record: {},
      type: "",
      title: "查看详情",
      defaultImg: "",
      listImageUrl: "",
      detailImageUrl: "",
      btnLoading: false,
      tableData: [
        {
          dataName: "注册会员",
          type: 1,
          price: 0.0,
        },
        {
          dataName: "初始会员",
          type: 2,
          price: 0.0,
        },
        {
          dataName: "荣誉会员",
          type: 3,
          price: 0.0,
        },
      ],
      ruleForm: {
        id: null,
        ctId: "",
        matchName: "",
        orgId: "",
        city: "",
        province: "",
        placeId: "",
        ctType: "",
        applySize: "",
        projectType: null,
        level: "",
        bench: "1",
        applyDate: [],
        matchSignStartTime: "",
        matchSignEndTime: "",
        matchStartTime: "",
        imgList: "",
        gameDescription: "",
        matchDescription: "",
        imgDetailList: "",
        repeatSign: "0",
        genderLimit: "2",
        ageLimit: "",
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: "",
        ctRefundList: [],
        byx1: "",
        verifyReason: "",
        minLevel: null, //级别限定
        maxLevel: null,
      },
      visible: false,
      rules: {
        // verifyReason: [
        //     { required: true, message: '审核意见不能为空!', trigger: 'blur' },
        //     {max: 200, message: '审核意见长度不能超过200个字符!'}
        // ]
      },
    };
  },
  filters: {
    dealAllowPlayOff(val) {
      let allowPlayOffData = [
        { label: "无附加赛", value: 0 },
        { label: "第三四名争夺季军", value: 1 },
      ];
      return allowPlayOffData.find((item) => item.value == val).label || "";
    },
  },
  methods: {
    zfsuccess(data) {
      this.visibleFee = false;
      console.log(data, 789);
      if (data == 1) {
        // this.$showLoading()
        this.$http({
          url: this.$http.adornUrl(`/frFranchiseFeeRecord/checkPayStatus`),
          method: "post",
          data: {
            busId: this.ruleForm.id,
            busType: 1,
            busCategory: 1,
          },
        }).then((data) => {
          if (data && data.code === 0) {
            this.visible = false;
            //缴费成功，直接发布
            this.updateState(2);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    init(id, type) {
      this.btnLoading = false
      this.title = "查看详情";
      this.ruleForm.id = id || null;
      this.visible = true;
      this.type = type;
      if (type == "release") {
        this.title = "审核发布";
        this.finachiseFeePay();
      }
      this.ruleForm.verifyReason = "";
      //回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ruleForm.id),
          method: "get",
        }).then((data) => {
          if (data && data.code === 0) {
            this.pdfs = data.bean.attachmentsList;
            this.ruleForm = data.bean;
            this.listImageUrl = data.bean.imgUrlList;
            this.detailImageUrl = data.bean.imgUrlDetail;
            this.ruleForm.applyDate = [];
            this.ruleForm.applyDate.push(data.bean.matchSignStartTime);
            this.ruleForm.applyDate.push(data.bean.matchSignEndTime);
            this.ruleForm.ctRefundList = [];
            // this.listImageUrlCert = data.eCertList
            this.eList = data.bean.ecertList;
            for (let i of data.eList) {
              for (let j of this.tableData) {
                if (i.type == j.type) {
                  j.price = i.price;
                  break;
                }
              }
            }
            this.ruleForm.verifyReason = "";

            let index = 1;
            for (let i of data.rList) {
              this.ruleForm.ctRefundList.push({
                index: index++,
                minDuration: i.minDuration,
                refundScale: i.refundScale,
              });
            }
          }
        });
      }
    },
    releaseSubmit(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (type === 2) {
            this.$confirm("是否发布比赛?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
                //status状态(0未缴费，1已缴费，2已退费)
                if (this.record.type === 1 && this.record.status === 0) {
                  //仅未支付预缴费时，展示二维码支付页面
                  this.visibleFee = true;
                } else {
                  //不是预缴费，则直接发布
                  this.updateState(type);
                }
                // this.updateState(type)
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消发布",
                });
              });
          } else if (type === 5) {
            this.updateState(type);
          }
        }
      });
    },
    //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
    finachiseFeePay() {
      this.$http({
        url: this.$http.adornUrl(`/frFranchiseFeeRecord/createQrCode`),
        method: "post",
        data: {
          busId: this.ruleForm.id,
          busType: 1,
          busCategory: 1,
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.record = data.record;
          console.log("record", this.record);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 数据处理
    CompetitionSelection(val, index) {
      if (val) {
        if (this.ruleForm.competitionMatchFormatList.length > 0) {
          if (val.length && index == 1) {
            return this.ruleForm.competitionMatchFormatList[0].matchFormat == 0
              ? "淘汰附加赛"
              : this.ruleForm.competitionMatchFormatList[0].matchFormat == 1
              ? "小组循环赛"
              : this.ruleForm.competitionMatchFormatList[0].matchFormat == 5
              ? "淘汰赛"
              : "";
          }
          if (val.length && index == 11) {
            return this.ruleForm.competitionMatchFormatList[0].groupNum;
          }
        }

        if (this.ruleForm.competitionMatchFormatList.length > 1) {
          if (val.length && index == 2) {
            // return this.ruleForm
            //     .competitionMatchFormatList[1]
            //     .matchFormat == 2
            //     ? '同名次小组循环赛'
            //     : this.ruleForm
            //             .competitionMatchFormatList[1]
            //             .matchFormat == 3
            //         ? '同名次淘汰附加赛'
            //         : this.ruleForm
            //                 .competitionMatchFormatList[1]
            //                 .matchFormat == 4
            //             ? '交叉淘汰附加赛'
            //             : ''
            let matchName = "";
            let matchFormat =
              this.ruleForm.competitionMatchFormatList[1].matchFormat;
            switch (matchFormat) {
              case 2:
                matchName = "同名次小组循环赛";
                break;
              case 3:
                matchName = "同名次淘汰附加赛";
                break;
              case 4:
                matchName = "交叉淘汰附加赛";
                break;
              case 5:
                matchName = "淘汰赛";
                break;
            }
            return matchName;
          }
          if (val.length && index == 22) {
            return this.ruleForm.competitionMatchFormatList[1].crossNum;
          }
        }
      }
    },
    CompetitionSelection1(val, index) {
      console.log("--------", val, index);
      let matchName = "";
      if (val.length > 1 && index == 2) {
        if (val[1]["allowPlayOff"] === 0) {
          matchName = "无附加赛";
        }
        if (val[1]["allowPlayOff"] === 1) {
          matchName = "第三四名争夺季军";
        }

      }
      return matchName;
    },
    updateState(type) {
      this.btnLoading = true
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/updateStatus`),
        method: "post",
        params: this.$http.adornParams({
          status: type,
          id: this.ruleForm.id,
          verifyReason: this.ruleForm.verifyReason,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: "审核成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.visible = false;
              this.$emit("refreshDataList");
            },
          });
        } else {
          this.btnLoading = false
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },
  },
};
</script>
<style>
.comecs .el-form-item__content {
  display: flex;
}
.el-table__header {
  width: 100% !important;
}
.el-table__body {
  width: 100% !important;
}
* {
  margin: 0;
}
</style>
